import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import VuetifyConfirm from 'vuetify-confirm'

Vue.use(Vuetify)

const vuetify = new Vuetify({
  icons: {
    iconfont: 'mdiSvg'
  },
  theme: {
    options: {
      customProperties: true
    },
    themes: {
      light: {
        primary: '#244b93',
        secondary: '#5b3e97',
        accent: '#8c9eff',
        error: '#c21e51',
        grey: '#9E9E9E'
      }
    }
  }
})

Vue.use(VuetifyConfirm, { vuetify })

export default vuetify
